import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 100%;
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `}
`;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    gap: 16px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
    max-width: 600px;
  `}
`;

export const Circle = styled.span`
  ${({
    theme, hideOnMobile, displayOnMobile, hideOnDesktop,
  }) => css`
      align-items: center;
      background-color: ${theme.v2.colors.brand.primaryExtraDark};
      border-radius: 100%;
      color: ${theme.v2.colors.white.primary};
      display: flex;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.bold};
      height: 10px;
      justify-content: center;
      padding: 10px;
      width: 10px;

      ${hideOnMobile && css`
        @media(max-width: ${theme.v2.breakpoints.sm}) {
          display: none;
        }
      `}

      ${hideOnDesktop && css`
        @media (min-width: ${theme.v2.breakpoints.sm}) {
          display: none;
        }
      `}

      ${displayOnMobile && css`
        @media (max-width: ${theme.v2.breakpoints.sm}) {
          display: inline-flex;
        }
      `}
  `}
`;

export const ContentRow = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  max-width: 100%;
  width: 100%;
`;

export const ContentColumn = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 16px;
    justify-content: flex-start;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin-top: 32px;
    }
  `};
`;

export const ServersBlocks = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
  `}
`;

export const ServerLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ServerValue = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const MessageWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryUltralight};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    margin: 24px 0px 0px;
    padding: 16px 0px 32px;
  `}
`;

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    margin: 16px 0px 0px;
     span {
      color: ${theme.v2.colors.brand.primaryMedium};
    }
  `}
`;

export const InpuWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-start;
  margin: 8px 0px 0px;
  max-width: 400px;
  position: relative;
  width: 100%;

  > div {
    width: 100% !important;
  }
`;

export const HelpCenterWrapper = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 16px 0px 0px;
  `}
`;

export const InputLabel = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const GoToLinkWrapper = styled.div`
  margin: 8px 0px 0px;
`;

export const ActionsRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin: 75px 0px 0px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: unset;
      flex-direction: column-reverse;
      justify-content: unset;
      margin: 24px 0px 0px;
      min-width: 100%;

      > span {
        display: flex;
        align-items: unset;
        justify-content: unset;
        min-width: 100%;

        button {
          min-width: 100%;
        }
      }
    }
  `}
`;
